import React from 'react';
import { useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import PageLayout from '../../components/PageLayout';
import AccountDetailContent from '../../components/account/AccountDetailContent';
import { adminAPI } from '../../services/api';

export default function AdminAccountDetail() {
  const navigate = useNavigate();
  const { accountId } = useParams<{ accountId: string }>();

  const { data: accountData, isLoading } = useQuery(
    ['admin-account-detail-header', accountId],
    async () => {
      const response = await adminAPI.getAccount(accountId!);
      return response.data;
    },
    { enabled: !!accountId },
  );

  const account = accountData
    ? { id: accountData.id, name: accountData.name, customer_count: accountData.customer_count }
    : accountId
    ? { id: accountId, name: isLoading ? 'Loading...' : 'Account' }
    : null;

  return (
    <PageLayout
      className="space-y-6"
      children={(
        <div className="space-y-6">
          <div className="flex flex-wrap items-center justify-between gap-4">
            <div className="min-w-0">
              <button
                type="button"
                onClick={() => navigate('/admin/accounts')}
                className="btn-tertiary mb-1 inline-flex items-center gap-1.5 text-sm"
              >
                <ArrowLeftIcon className="h-4 w-4" />
                Accounts
              </button>
              <h1 className="text-2xl font-bold text-on-surface">
                {isLoading ? 'Loading...' : (accountData?.name ?? 'Account')}
              </h1>
              {accountId && (
                <p className="mt-0.5 text-sm text-on-surface-variant">Account ID: {accountId}</p>
              )}
            </div>
          </div>

          {account && (
            <AccountDetailContent
              account={account}
              onAccountUpdated={() => {}}
            />
          )}
        </div>
      )}
    />
  );
}
